const isMissingInstructionalDepth = (courses) => {
  return !courses.every((course) => course.instructionalDepth)
}
export default isMissingInstructionalDepth
